import { AppSidebar } from "./sidebar/Index";
import Breadcrumbs from "./Breadcrumbs.tsx";
import { Outlet } from "react-router-dom";
import {ReactNode} from "react"
import { Separator }  from "../components/ui/separator"
import {
  SidebarInset,
  SidebarProvider,
  SidebarTrigger,
} from "../components/ui/sidebar"
import { UserProvider } from "../contexts/UserContext";

const Layout = ({ children }: { children: React.ReactNode }) => {
  return (
    <UserProvider>
    <SidebarProvider>
        {/* Sidebar */}
        <AppSidebar />

         <SidebarInset>
            <header className="flex h-16 shrink-0 items-center gap-2 transition-[width,height] ease-linear group-has-data-[collapsible=icon]/sidebar-wrapper:h-12">
              <div className="flex items-center gap-2 px-4 ">
                <SidebarTrigger className="-ml-1" />
                <Separator
                  orientation="vertical"
                  className="mr-2 data-[orientation=vertical]:h-4"
                />
                <Breadcrumbs/>
              </div>
            </header>
            <div className="p-3">
              <Outlet/>

            </div>
         </SidebarInset>
        
    </SidebarProvider>
    </UserProvider>
  );
};

export default Layout;
